const moment = require("moment-timezone");
import api from "@/services/api";
import httpClient from "@/services/httpClient";
import { server } from "@/services/constants";
import router from "@/router";
import * as productApis from "@/services/api-dtime/api_product.js";
import * as masterApis from "@/services/api-dtime/api_master.js";
import * as accountApis from "@/services/api-dtime/api_account.js";
import * as customerApis from "@/services/api-dtime/api_customer.js";
import * as currencyApis from "@/services/api-dtime/api_currency.js";
import * as groupMenuApis from "@/services/api-dtime/api_group_menu.js";
import * as settingGroupMenuApis from "@/services/api-dtime/api_setting_group_menu.js";
import * as menuDetailApis from "@/services/api-dtime/api_menu_detail.js";
import * as settingMenuDetailApis from "@/services/api-dtime/api_setting_menu_detail.js";
import * as advanceApis from "@/services/api-dtime/api_advance.js";
import * as advanceHApis from "@/services/api-dtime/api_advance_h.js";
import * as advanceDApis from "@/services/api-dtime/api_advance_d.js";
import * as advanceCodeApis from "@/services/api-dtime/api_advance_code.js";
import * as advanceLogApis from "@/services/api-dtime/api_advance_log.js";
import * as departmentApis from "@/services/api-dtime/api_department.js";
import * as salesorderApis from "@/services/api-dtime/api_sales_order.js";
import * as salesorderdetailApis from "@/services/api-dtime/api_sales_order_d.js";
import * as companyApis from "@/services/api-dtime/api_company.js";
import * as positionApis from "@/services/api-dtime/api_position.js";
import * as jobtitleApis from "@/services/api-dtime/api_jobtitle.js";
import * as timsheetHApis from "@/services/api-dtime/api_timesheet_h.js";
import * as timsheetDApis from "@/services/api-dtime/api_timesheet_d.js";
import * as activityApis from "@/services/api-dtime/api_activity.js";
import * as leavequotaApis from "@/services/api-dtime/api_leavequota.js";
import * as leaveApis from "@/services/api-dtime/api_leave.js";
import * as api_LEAVE_HISTORY_QUOTA_DETAIL from "@/services/api-dtime/api_leave_history_quota_detail.js";
import * as api_leave_holiday from "@/services/api-dtime/api_leave_holiday.js";
import * as api_company_event from "@/services/api-dtime/api_company_event.js";
import * as invoice_hApis from "@/services/api-dtime/api_invoice_h.js";
import * as api_inv_soApis from "@/services/api-dtime/api_inv_so.js";
import * as api_inv_docrefApis from "@/services/api-dtime/api_inv_docref.js";
import * as api_leave_approve_detail from "@/services/api-dtime/api_leave_approve_detail.js";
import * as api_inv_miscellaneous from "@/services/api-dtime/api_inv_miscellaneous.js";
import * as api_trc_h from "@/services/api-dtime/api_trc_h.js";
import * as api_trc_d from "@/services/api-dtime/api_trc_d.js";
import * as api_inv_ts from "@/services/api-dtime/api_inv_ts.js";
import * as api_inv_title from "@/services/api-dtime/api_inv_title.js";
import * as api_im_principal from "@/services/api-dtime/api_im_principal.js";
import * as api_im_participant from "@/services/api-dtime/api_im_participant.js";

import * as api_doctype from "@/services/api-dtime/api_doctype.js";
import * as api_file_attach_at_law from "@/services/api-dtime/api_file_attach_at_law";
import * as api_doctitle_template from "@/services/api-dtime/api_doctitle_template.js";
import * as api_docdropdown from "@/services/api-dtime/api_docdropdown.js";
import * as api_im_inv from "@/services/api-dtime/api_im_inv.js";
import * as api_doctrans from "@/services/api-dtime/api_doctrans.js";
import * as api_doctrans_h from "@/services/api-dtime/api_doctrans_h.js";

import * as api_im_transaction from "@/services/api-dtime/api_im_transaction.js";
import * as api_im_transaction_dependent from "@/services/api-dtime/api_im_transaction_dependent.js";
import * as api_im_docket from "@/services/api-dtime/api_im_docket.js";
import * as api_miscellaneous_list from "@/services/api-dtime/api_miscellaneous_list.js";
import * as im_master_place_of_issue from "@/services/api-dtime/im_master_place_of_issue.js";
import * as im_master_work_place_of_issue from "@/services/api-dtime/im_master_work_place_of_issue.js";
import * as api_tranning_h from "@/services/api-dtime/api_tranning_h.js";
import * as api_tranning_d from "@/services/api-dtime/api_tranning_d.js";
import * as api_tranning_email from "@/services/api-dtime/api_tranning_email.js";
import * as api_tranning_user from "@/services/api-dtime/api_tranning_user.js";
import * as api_tranning_user_d from "@/services/api-dtime/api_tranning_user_d.js";
import * as api_transactions_log from "@/services/api-dtime/api_transaction_log.js";
import * as api_log_in_out_log from "@/services/api-dtime/api_log_in_out_log.js";
import * as api_pettycash_h from "@/services/api-dtime/api_pettycash_h.js";
import * as api_pettycash_d from "@/services/api-dtime/api_pettycash_d.js";
import * as api_file_attach from "@/services/api-dtime/api_file_attach.js";
import * as api_register_company from "@/services/api-dtime/api_register_company.js";
import * as api_leave_type from "@/services/api-dtime/api_leave_type.js";
import * as api_doc_running from "@/services/api-dtime/api_docrunning.js";
import * as api_approver_management from "@/services/api-dtime/api_approver_management.js";
import * as api_report_all from "@/services/api-dtime/api_report_all.js";
import * as api_section_access_config from "@/services/api-dtime/api_section_access_config.js";
import * as api_client_timeline_status from "@/services/api-dtime/api_client_timeline_status.js";
import * as api_client_timeline_history from "@/services/api-dtime/api_client_timeline_history.js";
import * as api_client_timeline_status_config from "@/services/api-dtime/api_client_timeline_status_config.js";
import * as api_quotations_core from "@/services/api-dtime/api_quotations_core.js";
import * as api_uploadfile from "@/services/api-dtime/api_uploadfile.js";
import * as api_im_nationality from "@/services/api-dtime/api_im_nationality.js";
import * as api_im_case_type from "@/services/api-dtime/im_case_type.js";

////---------------at law services--------------///
import * as mastertmApis from "@/services/api-ip-at-law/api_mastertm.js";
import * as api_change_master_recordApis from "@/services/api-ip-at-law/api_change_master_record.js";
import * as objecttypeApis from "@/services/api-ip-at-law/api_objecttype.js";
import * as contactApis from "@/services/api-ip-at-law/api_contact.js";
import * as tmupdatestatusApis from "@/services/api-ip-at-law/api_tmupdatestatus.js";
import * as masterptApis from "@/services/api-ip-at-law/api_masterpt.js";
import * as documenttypeApis from "@/services/api-ip-at-law/api_documenttype.js";
import * as appointmentApis from "@/services/api-ip-at-law/api_appointment.js";
import * as appointmentDocumenttypeActionApis from "@/services/api-ip-at-law/api_appointment_documenttype_action.js";
import * as countryApis from "@/services/api-ip-at-law/api_country.js";
import * as api_doctype_actions from "@/services/api-ip-at-law/api_doctype_actions.js";
import * as api_masterpt_priority from "@/services/api-ip-at-law/api_masterpt_priority.js";
import * as api_decision from "@/services/api-ip-at-law/api_decision.js";
import * as noticeApis from "@/services/api-ip-at-law/api_notice.js";
import * as POAApis from "@/services/api-ip-at-law/api_poa.js";
import * as OCRApis from "@/services/api-ip-at-law/api_ocr.js";
import * as OCRKWApis from "@/services/api-ip-at-law/api_ocrkw.js";
import * as api_ip_prcie_list from "@/services/api-ip-at-law/api_ip_prcie_list.js";
import * as api_ip_inv from "@/services/api-ip-at-law/api_ip_inv.js";

//billing_expense service
import * as api_billing_expense_miscellaneous from "@/services/billing_expense/api_billing_expense_miscellaneous.js";
import * as api_billing_expense_inv_title from "@/services/billing_expense/api_billing_expense_inv_title.js";
import * as api_billing_expense_department from "@/services/billing_expense/api_billing_expense_department.js";
import * as api_billing_expense_invoice_h from "@/services/billing_expense/api_billing_expense_invoice_h.js";
import * as api_billing_expense_advance_h from "@/services/billing_expense/api_billing_expense_advance_h.js";
import * as api_billing_expense_advance_code from "@/services/billing_expense/api_billing_expense_advance_code.js";
import * as api_billing_expense_advance_d from "@/services/billing_expense/api_billing_expense_advance_d.js";
import * as api_billing_expense_advance_log from "@/services/billing_expense/api_billing_expense_advance_log.js";
import * as api_billing_expense_pettycash_h from "@/services/billing_expense/api_billing_expense_pettycash_h.js";
import * as api_billing_expense_pettycash_d from "@/services/billing_expense/api_billing_expense_pettycash_d.js";
import * as api_billing_expense_file_attach from "@/services/billing_expense/api_billing_expense_file_attach.js";
import * as api_billing_expense_inv_so from "@/services/billing_expense/api_billing_expense_inv_so.js";
import * as api_billing_expense_inv_docref from "@/services/billing_expense/api_billing_expense_inv_docref.js";
import * as api_billing_expense_timesheet_d from "@/services/billing_expense/api_billing_expense_timesheet_d.js";
import * as api_billing_expense_inv_ts from "@/services/billing_expense/api_billing_expense_inv_ts.js";
import * as api_billing_expense_inv_miscellaneous from "@/services/billing_expense/api_billing_expense_inv_miscellaneous.js";
import * as api_billing_expense_sales_order from "@/services/billing_expense/api_billing_expense_sales_order.js";
import * as api_billing_expense_timesheet_h from "@/services/billing_expense/api_billing_expense_timesheet_h.js";
import * as api_billing_expense_sales_order_d from "@/services/billing_expense/api_billing_expense_sales_order_d.js";
import * as api_billing_expense_trc_h from "@/services/billing_expense/api_billing_expense_trc_h.js";
import * as api_billing_expense_trc_d from "@/services/billing_expense/api_billing_expense_trc_d.js";
import * as api_billing_expense_payment_invoice from "@/services/billing_expense/api_billing_expense_payment_invoice.js";
import * as api_billing_expense_quotations from "@/services/billing_expense/api_billing_expense_quotations.js";
import * as api_billing_expense_quotations_item from "@/services/billing_expense/api_billing_expense_quotations_item.js";

//-------------------incorporate matter------------------//
import * as api_incorporate from "@/services/api-dtime/api_incorporate.js";
import * as api_incorporate_docket_doc_category from "@/services/api-dtime/api_incorporate_docket_doc_category.js";
//api-dispute-resolution
import * as api_litigation_casetype from "@/services/api-dispute-resolution/api_litigation_casetype.js";
import * as api_litigation_court from "@/services/api-dispute-resolution/api_litigation_court.js";
import * as api_litigation_court_status from "@/services/api-dispute-resolution/api_litigation_court_status.js";
import * as api_litigation_courtlevel from "@/services/api-dispute-resolution/api_litigation_courtlevel.js";
import * as api_litigation_department from "@/services/api-dispute-resolution/api_litigation_department.js";
import * as api_litigation_dispute_resolution_docket from "@/services/api-dispute-resolution/api_litigation_dispute_resolution_docket.js";
import * as api_litigation_additional_lawyers from "@/services/api-dispute-resolution/api_litigation_additional_lawyers.js";
import * as api_litigation_hearings from "@/services/api-dispute-resolution/api_litigation_hearings.js";

const isLoggedIn = () => {
  let token = localStorage.getItem(server.TOKEN_KEY);
  return token != null;
};

// ⭐ ใหม่ — รวม logic เซฟ session ไว้ที่เดียว ใช้ซ้ำได้ทั้ง login ปกติ และหลัง verify OTP
const persistLoginSession = (data, username) => {
  localStorage.setItem(server.USERNAME, username);
  localStorage.setItem(server.USER_ID, data.user_id);
  localStorage.setItem(server.TOKEN_KEY, data.token);
  localStorage.setItem(
    server.FULLNAME,
    data.acc_fullname !== "  "
      ? data.acc_fullname
      : data.acc_fullname_en !== "  "
        ? data.acc_fullname_en
        : "",
  );
  localStorage.setItem(server.ROLE, data.role);
  localStorage.setItem(server.COMPANYID, data.company_id);
  localStorage.setItem(server.DEPARTMENT_ID, data.department_id);
  localStorage.setItem(server.POSITION_ID, data.position_id);
  localStorage.setItem(server.AUTHORIZE_ID, data.authorize_id);
  localStorage.setItem(server.EMAIL_URL, data.email);
  localStorage.setItem(server.VERSION, data.v_web);
  localStorage.setItem(server.APPROVE_LEVEL1, data.approver_level1);
  localStorage.setItem(server.APPROVE_LEVEL1_EMAIL, data.approver_level1_email);
  localStorage.setItem(server.LOGIN_ID, data.login_id);
};

const login = async (values) => {
  try {
    const result = await httpClient.post(
      server.ACCOUNT_URL + "/loginforweb",
      values,
    );

    if (result.status == 201) {
      if (result.data && result.data.success === false) {
        let errorData = new Error(result.data.message || "Invalid Credentials");
        errorData.response = result;
        throw errorData;
      }

      // ⭐ ใหม่ — backend บอกว่าต้องยืนยัน OTP (SMS) ก่อน ยังไม่ได้ token
      if (result.data && result.data.require_otp === true) {
        return {
          require_otp: true,
          user_id: result.data.user_id,
          company_code: result.data.company_code,
          username: result.data.username,
          otp_token: result.data.otp_token, // ⭐ ต้องเก็บไว้ใช้ตอน verify
          ref_code: result.data.ref_code, // ⭐ ต้องเก็บไว้ใช้ตอน verify
          phone_masked: result.data.phone_masked,
        };
      }

      if (result.data && result.data.success === true) {
        if (result.data.token) {
          persistLoginSession(result.data, values.username);
          return true;
        } else {
          let errorData = new Error(
            result.data.message || "Invalid Credentials",
          );
          errorData.response = result;
          throw errorData;
        }
      } else {
        throw new Error("Invalid Response Data");
      }
    } else if (result.status == 503 && result.data.ip_error) {
      let errorData = new Error(result.data.ip_error);
      errorData.response = result;
      errorData.isIpError = true;
      throw errorData;
    }
  } catch (error) {
    if (error.response?.status == 503 && error.response?.data?.ip_error) {
      alert(error.response.data.ip_error);
      return false;
    }
    throw error;
  }
};

// ⭐ ใหม่ — ขั้นตอนที่ 2: ยืนยัน OTP หลัง login
const verifyLoginOtp = async ({
  company_code,
  username,
  otp_token,
  ref_code,
  otp_code,
  remember_device,
}) => {
  const result = await httpClient.post(
    server.ACCOUNT_URL + "/verify-login-otp",
    { company_code, username, otp_token, ref_code, otp_code, remember_device, onweb: true },
  );

  if (result.data && result.data.success === false) {
    let errorData = new Error(result.data.message || "OTP ไม่ถูกต้อง");
    errorData.response = result;
    throw errorData;
  }

  if (result.data && result.data.token) {
    persistLoginSession(result.data, username);
    return true;
  }

  throw new Error("Invalid Response Data");
};

// ⭐ ใหม่ — ปุ่ม "Resend code" (ส่ง user_id พอ backend จะไปดึงเบอร์โทรเองจาก DB)
const resendLoginOtp = async ({ user_id }) => {
  const result = await httpClient.post(
    server.ACCOUNT_URL + "/resend-login-otp",
    { user_id },
  );

  if (result.data && result.data.success === false) {
    let errorData = new Error(result.data.message || "ส่ง OTP ไม่สำเร็จ");
    errorData.response = result;
    throw errorData;
  }

  return result.data; // { success, otp_token, ref_code, message }
};

const register = async (values) => {
  let result = await httpClient.post(server.REGISTER_URL, values);
  if (result.data.result == "ok") {
    router.go(-1);
  } else {
    alert(JSON.stringify(result));
  }
};

const logoff = () => {
  localStorage.removeItem(server.TOKEN_KEY);
  localStorage.clear();
  router.push("/login");
};

const checkVersion = async () => {
  try {
    const version = localStorage.getItem(server.VERSION);
    // console.log("checkVersion version:", version);
    if (version !== "106") {
      var dataEdit = {
        date_out: moment()
          .add(7, "hours")
          .format("YYYY-MM-DD HH:mm:ss"),
      };
      await api.updateLogInOutLog(
        localStorage.getItem(server.LOGIN_ID),
        dataEdit,
      );

      // this.$store.dispatch("doLogout");
      localStorage.removeItem(server.TOKEN_KEY);
      localStorage.clear();
      // router.push("/login");
    }
  } catch (error) {
    var dataEdit = {
      date_out: moment()
        .add(7, "hours")
        .format("YYYY-MM-DD HH:mm:ss"),
    };
    await api.updateLogInOutLog(
      localStorage.getItem(server.LOGIN_ID),
      dataEdit,
    );

    // this.$store.dispatch("doLogout");
    localStorage.removeItem(server.TOKEN_KEY);
    localStorage.clear();
    // router.push("/login");
    console.log("checkVersion error:", error);
  }
};

export default {
  isLoggedIn,
  login,
  verifyLoginOtp,
  resendLoginOtp,
  register,
  logoff,
  checkVersion,
  ...productApis,
  ...accountApis,
  ...customerApis,
  ...currencyApis,
  ...groupMenuApis,
  ...menuDetailApis,
  ...settingGroupMenuApis,
  ...settingMenuDetailApis,
  ...masterApis,
  ...advanceApis,
  ...advanceHApis,
  ...advanceDApis,
  ...advanceCodeApis,
  ...advanceLogApis,
  ...departmentApis,
  ...salesorderApis,
  ...salesorderdetailApis,
  ...companyApis,
  ...positionApis,
  ...jobtitleApis,
  ...timsheetHApis,
  ...timsheetDApis,
  ...activityApis,
  ...leavequotaApis,
  ...leaveApis,
  ...invoice_hApis,
  ...api_inv_soApis,
  ...api_inv_docrefApis,
  ...api_leave_approve_detail,
  ...api_inv_miscellaneous,
  ...api_trc_h,
  ...api_trc_d,
  ...api_inv_ts,
  ...api_im_principal,
  ...api_im_participant,
  ...api_doctype,
  ...api_file_attach_at_law,
  ...api_doctitle_template,
  ...api_docdropdown,
  ...api_im_inv,
  ...api_doctrans,
  ...api_im_transaction,
  ...api_im_transaction_dependent,
  ...api_im_docket,
  ...api_doctrans_h,
  ...api_inv_title,
  ...api_miscellaneous_list,
  ...im_master_place_of_issue,
  ...im_master_work_place_of_issue,
  ...api_LEAVE_HISTORY_QUOTA_DETAIL,
  ...api_company_event,
  ...api_leave_holiday,
  ...api_transactions_log,
  ...api_log_in_out_log,
  ...api_tranning_h,
  ...api_tranning_d,
  ...api_tranning_email,
  ...api_tranning_user,
  ...api_tranning_user_d,
  ...api_pettycash_h,
  ...api_pettycash_d,
  ...api_file_attach,
  ...api_register_company,
  ...api_leave_type,
  ...api_doc_running,
  ...api_approver_management,
  ...api_report_all,
  ...api_section_access_config,
  ...api_client_timeline_status,
  ...api_client_timeline_history,
  ...api_client_timeline_status_config,
  ...api_quotations_core,
  ...api_uploadfile,
  ...api_im_nationality,
  ...api_im_case_type,

  ////--------------at la service---------------------////
  ...mastertmApis,
  ...api_change_master_recordApis,
  ...objecttypeApis,
  ...contactApis,
  ...tmupdatestatusApis,
  ...masterptApis,
  ...documenttypeApis,
  ...appointmentApis,
  ...appointmentDocumenttypeActionApis,
  ...countryApis,
  ...noticeApis,
  ...POAApis,
  ...OCRApis,
  ...OCRKWApis,
  ...api_ip_prcie_list,
  ...api_ip_inv,
  ...api_doctype_actions,
  ...api_masterpt_priority,
  ...api_decision,

  //billing expense service
  ...api_billing_expense_miscellaneous,
  ...api_billing_expense_inv_title,
  ...api_billing_expense_department,
  ...api_billing_expense_invoice_h,
  ...api_billing_expense_advance_h,
  ...api_billing_expense_advance_code,
  ...api_billing_expense_advance_d,
  ...api_billing_expense_advance_log,
  ...api_billing_expense_pettycash_h,
  ...api_billing_expense_pettycash_d,
  ...api_billing_expense_file_attach,
  ...api_billing_expense_inv_so,
  ...api_billing_expense_inv_docref,
  ...api_billing_expense_timesheet_d,
  ...api_billing_expense_inv_ts,
  ...api_billing_expense_inv_miscellaneous,
  ...api_billing_expense_sales_order,
  ...api_billing_expense_timesheet_h,
  ...api_billing_expense_sales_order_d,
  ...api_billing_expense_trc_h,
  ...api_billing_expense_trc_d,
  ...api_billing_expense_payment_invoice,
  ...api_billing_expense_quotations,
  ...api_billing_expense_quotations_item,

  //api-dispute-resolution
  ...api_litigation_casetype,
  ...api_litigation_court,
  ...api_litigation_court_status,
  ...api_litigation_courtlevel,
  ...api_litigation_department,
  ...api_litigation_dispute_resolution_docket,
  ...api_litigation_additional_lawyers,
  ...api_litigation_hearings,

  //-------------------incorporate matter------------------//
  ...api_incorporate,
  ...api_incorporate_docket_doc_category,
};
